import { Link, Route, Routes } from 'react-router-dom';

// Third-party packages.
import Helmet from 'react-helmet';

// Views.
import List from './List';
import Breadcrumb from "../../container/breadcrumb";
import ConditionalRender from "../../helpers/ConditionalRender";

export default function Recommendation ()
{

	return (
		<div id="content">
			<Helmet>
				<title>Recommendations - DBmarlin</title>
				<meta name="description" content="View recommendations" />
			</Helmet>

			{/* Heading */}
			<div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
				<Breadcrumb heading="Recommendations">
					<Link to="/recommendations">Analysis</Link>
					<span>Recommendations</span>
				</Breadcrumb>
			</div>

			<div className="loader">
				<ConditionalRender if={false}>
					<div className="bar"></div>
				</ConditionalRender>
			</div>

			<div className="row row-cols-1">
				<Routes>
					<Route path="/" element={<List />} />
				</Routes>
			</div>
		</div>
	);
}
